
import { StepIndicatorProps } from "../../types";

export const StepIndicator: React.FC<StepIndicatorProps & { isLast?: boolean }> = ({
  step,
  isActive,
  isCompleted,
  isLast = false,
}) => {
 
  return (
    
    <div className="flex w-full items-center flex-1">
      {/* Step badge + label */}
      <div className="flex items-center gap-2 flex-shrink-0">
        {/* Number badge — uses step.id as the number */}
        <div
          className={`w-6 h-6 rounded-md flex items-center justify-center text-xs font-semibold flex-shrink-0 transition-all ${
            isActive
              ? "bg-green-500 text-white"
              : isCompleted
              ? "bg-green-500 text-white"
              : "bg-transparent text-gray-400 border border-gray-300"
          }`}
        >
          {step.id}
        </div>

        {/* Label */}
        <span
          className={`text-sm font-medium whitespace-nowrap transition-all ${
            isActive
              ? "text-gray-900"
              : isCompleted
              ? "text-gray-700"
              : "text-gray-400"
          }`}
        >
          {step.title}
        </span>
      </div>

      {/* Connecting line — hidden on last step */}
      {!isLast && (
        <div className="flex-1 mx-4 h-px bg-gray-200 min-w-[32px]" />
      )}
    </div>
  );
};